import React from 'react';
import { Content, Row, Col, Title, Text, Button } from 'components';
import { SideMenu } from '../components';
import { Empty } from 'antd';
import MessageAlert from 'utils';

/* 배송지 목록 */
// const initialAdressList = [
//   {
//     address_name: '제이엠1',
//     phone_number: '010-1234-5678',
//     address_data:
//       '(46079) 부산광역시 기장군 기장읍 대변3길 8 제이엠커피로스터스',
//     delivery_message: '부재시 경비실에 맡겨주세요.',
//     type: 'active', // 기본 배송지
//   },
//   {
//     address_name: '제이엠2',
//     phone_number: '010-1234-5678',
//     address_data:
//       '(46079) 부산광역시 기장군 기장읍 대변3길 8 제이엠커피로스터스',
//     delivery_message: '부재시 경비실에 맡겨주세요.',
//     type: 'inactive', // 일반 배송지
//   },
//   {
//     address_name: '제이엠3',
//     phone_number: '010-1234-5678',
//     address_data:
//       '(46079) 부산광역시 기장군 기장읍 대변3길 8 제이엠커피로스터스',
//     delivery_message: '부재시 경비실에 맡겨주세요.',
//     type: 'inactive', // 일반 배송지
//   },
// ];

const MypageAddressPresenter = (props) => {
  /* ===== Props ===== */
  const { user, address, onDelete, onOpenPopup, screenSize } = props;

  /* ===== State ===== */

  /* ===== Function ===== */

  /* ===== Variables ===== */
  const styles = {
    titleLayout: {
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      paddingBottom: 24,
      borderBottom: '2px solid var(--black-color)',
    },
    title: {
      fontSize: screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
      fontWeight: 700,
      color: 'var(--black-color)',
    },
  };

  /* ===== Render ===== */
  return (
    <Content
      maxWidth={1820}
      padding={screenSize >= 768 ? '120px 0px' : '60px 0'}
    >
      <Row gutter={25}>
        <Col x={0} md={1} xl={2}></Col>
        <Col x={0} md={6} xl={4}>
          <SideMenu />
        </Col>
        <Col x={24} md={16} xl={16}>
          <Content
            maxWidth={'100%'}
            padding={
              screenSize >= 1200
                ? '0 0 0 95px'
                : screenSize >= 768
                  ? '0 0 0 20px'
                  : '0'
            }
          >
            <div style={{ ...styles.titleLayout }}>
              <Title style={{ ...styles.title }}>배송지 관리</Title>
            </div>
            {/* 배송지 관리 목록 */}
            <Content maxWidth={'100%'} style={{ padding: 0 }}>
              {!address?.length ? (
                <div
                  style={{
                    padding: '100px 0',
                    textAlign: 'center',
                    fontSize: 16,
                    color: 'var(--light-gray-color)',
                    borderBottom: '1px solid #ddd',
                  }}
                >
                  <Empty description={'등록된 배송지가 없습니다.'} />
                </div>
              ) : (
                address?.map((address, index) => (
                  <div
                    key={`address-${address?.delivery_address_id}`}
                    style={{
                      padding: '32px 0',
                      borderBottom: '1px solid #ddd',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          gap: 16,
                          alignItems: 'center',
                        }}
                      >
                        <Text>{address?.recipient_name}</Text>
                        {!address?.delivery_address_id ? (
                          address
                            ? <span
                              style={{
                                backgroundColor: 'var(--black-color)',
                                color: 'var(--white-color)',
                                padding: '2px 8px',
                              }}
                            >
                              기본배송지
                            </span>
                            : <span
                              style={{
                                backgroundColor: 'var(--black-color)',
                                color: 'var(--white-color)',
                                padding: '2px 8px',
                              }}
                            >
                              기본 배송지를 설정해주세요
                            </span>
                        ) : null}
                      </div>
                      <div style={{ display: 'flex', marginBottom: 4 }}>
                        {/* {address.type === 'inactive' && (
                          <Text>
                            <span
                              style={{
                                fontSize: 16,
                                fontWeight: 700,
                                paddingRight: 16,
                                cursor: 'pointer',
                              }}
                              onClick={() => setAsDefault(index)}
                            >
                              기본배송지로 변경
                            </span>
                          </Text>
                        )} */}
                        <Text>
                          <span
                            style={{
                              fontSize: screenSize >= 768 ? 16 : 14,
                              fontWeight: 700,
                              padding: '0 16px',
                              cursor: 'pointer',
                              borderLeft:
                                address?.type === 'inactive'
                                  ? '1px solid var(--black-color)'
                                  : 'none',
                            }}
                            onClick={() => {
                              if (address?.delivery_address_id) {
                                onOpenPopup('update', address);
                              } else {
                                MessageAlert.info(
                                  '기본 배송지는 회원정보 수정에서 가능합니다'
                                );
                              }
                            }}
                          >
                            수정
                          </span>
                        </Text>
                        {address?.delivery_address_id ? (
                          <Text>
                            <span
                              style={{
                                fontSize: screenSize >= 768 ? 16 : 14,
                                fontWeight: 700,
                                paddingLeft: 16,
                                borderLeft: '1px solid var(--black-color)',
                                cursor: 'pointer',
                              }}
                              onClick={() =>
                                onDelete(address?.delivery_address_id)
                              }
                            >
                              삭제
                            </span>
                          </Text>
                        ) : null}
                      </div>
                    </div>
                    <Text style={{ marginBottom: 4 }}>
                      {address?.recipient_phone ?? null}
                    </Text>
                    {address ? <Text style={{ webkitLineClamp: 'unset' }}>
                      ({address?.recipient_postcode}) {address?.recipient_address}{' '}
                      {address?.recipient_address_detail}
                    </Text>
                      : null
                    }
                    <Text
                      style={{
                        backgroundColor: '#f4f4f4',
                        padding: '16px 40px',
                        marginTop: 32,
                      }}
                    >
                      {address?.request ? address?.request : '-'}
                    </Text>
                  </div>
                ))
              )}
            </Content>
            <Content
              maxWidth={'100%'}
              justify={'center'}
              padding={0}
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 100,
              }}
            >
              <Button
                style={{
                  width: '22%',
                  minWidth: 145,
                  padding: screenSize >= 768 ? '18px 52px' : '12px 35px',
                  fontWeight: 700,
                  borderRadius: '2px',
                }}
                onClick={() => onOpenPopup('create', { user_id: user.user_id })}
              >
                배송지 등록
              </Button>
            </Content>
            {/* 배송지 관리 목록 끝 */}
          </Content>
        </Col>
        <Col x={0} md={1} xl={2}></Col>
      </Row>
    </Content>
  );
};

export default MypageAddressPresenter;
